import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authApi } from '../../api';
import TermsModal from '../../components/TermsModal/TermsModal';
import PrivacyModal from '../../components/PrivacyModal/PrivacyModal';
import '../Login/Login.css';
import './Register.css';

const Register = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    nombre: '',
    apellido: '',
    email: '',
    numero_documento: '',
    tipo_documento_id: 1,
    telefono: '',
    password: '',
    confirmar_password: '',
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [accepted, setAccepted] = useState(false);

  const handleChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!accepted) {
      setError('Debes aceptar los Términos y Condiciones y la Política de Privacidad.');
      return;
    }
    if (form.password !== form.confirmar_password) {
      setError('Las contraseñas no coinciden.');
      return;
    }
    setLoading(true);
    try {
      const { confirmar_password, ...body } = form;
      await authApi.registrar({ ...body, tipo_documento_id: Number(body.tipo_documento_id) });
      setSuccess('¡Cuenta creada! Ahora puedes iniciar sesión.');
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError(err.message || 'Error al crear la cuenta.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card auth-card--wide">
        <div className="auth-card__logo">
          <img src={process.env.PUBLIC_URL + '/cash_logo_color-06.png'} alt="Cash Sol SAC" />
        </div>
        <h2>Crear cuenta</h2>
        <p className="auth-card__sub">Regístrate para solicitar tu crédito</p>

        {error && <div className="auth-alert auth-alert--error">{error}</div>}
        {success && <div className="auth-alert auth-alert--success">{success}</div>}

        <form onSubmit={handleSubmit} className="auth-form register-form">
          <div className="register-grid">
            <div className="auth-field">
              <label>Nombre</label>
              <div className="auth-input-wrap">
                <i className="fa-solid fa-user"></i>
                <input name="nombre" value={form.nombre} onChange={handleChange}
                  placeholder="Juan" required />
              </div>
            </div>
            <div className="auth-field">
              <label>Apellidos</label>
              <div className="auth-input-wrap">
                <i className="fa-solid fa-user"></i>
                <input name="apellido" value={form.apellido} onChange={handleChange}
                  placeholder="Pérez García" required />
              </div>
            </div>
          </div>

          <div className="auth-field">
            <label>Correo electrónico</label>
            <div className="auth-input-wrap">
              <i className="fa-solid fa-envelope"></i>
              <input type="email" name="email" value={form.email} onChange={handleChange}
                placeholder="correo@email.com" required />
            </div>
          </div>

          <div className="register-grid">
            <div className="auth-field">
              <label>Tipo documento</label>
              <div className="auth-input-wrap">
                <i className="fa-solid fa-id-card"></i>
                <select name="tipo_documento_id" value={form.tipo_documento_id} onChange={handleChange}>
                  <option value={1}>DNI</option>
                  <option value={2}>Pasaporte</option>
                  <option value={3}>CE</option>
                </select>
              </div>
            </div>
            <div className="auth-field">
              <label>Número de documento</label>
              <div className="auth-input-wrap">
                <i className="fa-solid fa-id-badge"></i>
                <input name="numero_documento" value={form.numero_documento} onChange={handleChange}
                  placeholder="12345678" required maxLength={12} />
              </div>
            </div>
          </div>

          <div className="auth-field">
            <label>Teléfono</label>
            <div className="auth-input-wrap">
              <i className="fa-solid fa-phone"></i>
              <input name="telefono" value={form.telefono} onChange={handleChange}
                placeholder="987654321" required />
            </div>
          </div>

          <div className="register-grid">
            <div className="auth-field">
              <label>Contraseña</label>
              <div className="auth-input-wrap">
                <i className="fa-solid fa-lock"></i>
                <input type="password" name="password" value={form.password} onChange={handleChange}
                  placeholder="••••••••" required minLength={6} />
              </div>
            </div>
            <div className="auth-field">
              <label>Confirmar contraseña</label>
              <div className="auth-input-wrap">
                <i className="fa-solid fa-lock"></i>
                <input type="password" name="confirmar_password" value={form.confirmar_password}
                  onChange={handleChange} placeholder="••••••••" required minLength={6} />
              </div>
            </div>
          </div>

          <div className="auth-field auth-field--checkbox">
            <label className="auth-checkbox-label">
              <input
                type="checkbox"
                checked={accepted}
                onChange={(e) => setAccepted(e.target.checked)}
                required
              />
              <span>
                Acepto los{' '}
                <button type="button" className="auth-inline-link" onClick={() => setIsTermsOpen(true)}>
                  Términos y Condiciones
                </button>{' '}
                y la{' '}
                <button type="button" className="auth-inline-link" onClick={() => setIsPrivacyOpen(true)}>
                  Política de Privacidad
                </button>
              </span>
            </label>
          </div>

          <button type="submit" className="btn-primary auth-btn" disabled={loading || !accepted}>
            {loading ? <span className="spinner-sm"></span> : (
              <><i className="fa-solid fa-user-plus"></i> Crear cuenta</>
            )}
          </button>
        </form>

        <p className="auth-card__bottom">
          ¿Ya tienes cuenta?{' '}
          <Link to="/login" className="auth-link">Inicia sesión</Link>
        </p>
        <p className="auth-card__back">
          <Link to="/" className="auth-link">
            <i className="fa-solid fa-arrow-left"></i> Volver al inicio
          </Link>
        </p>
      </div>
      <TermsModal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} />
      <PrivacyModal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} />
    </div>
  );
};

export default Register;
